import { defineComponent as i, computed as r } from "vue";
import { submitInternalEventAndRedirectToPage as m } from "../../../shared/data/tracking/utilities/index.js";
import { TRACKING_EVENTS as p } from "../../../shared/data/tracking/types/index.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import "../../../shared/data/layout/state/index.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import { generateLogo as n } from "../../../shared/data/utilities/logo/index2.js";
const I = i({
  name: "HeaderLogo",
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  setup(t) {
    const e = () => {
      m(
        p.HEADER_LAW_DEPOT_CLICK,
        {
          url: "/"
        }
      );
    }, o = r(() => t.config.sitebrand);
    return {
      logoClass: r(
        () => n({ siteBrand: o.value, cssClass: "header" })
      ),
      sitebrand: o,
      redirectToHomePage: e
    };
  }
});
export {
  I as default
};
//# sourceMappingURL=index18.js.map
